export default {
        PaymentMethods: {
            invoice: 1,
            cardCredit: 2,
            cardType: 3,
        },
        PaymentMethod: {
            invoice: 0,
            cardCredit: 2,
        },
        CardHolderType: {
            organization: 1,
            department: 2,
            user: 3,
        },
        CardTypes: {
            visaDebit: 1,
            visaCredit: 2,
            masterCardCredit: 3,
            masterCardDebit: 4,
            americanExpress: 5,
        },
        BillbackPayOnDeparture: 2,
        PaymentSystem: {
            None: 0,
            Adflex: 1,
            Spreedly: 2,
        },
};



// WEBPACK FOOTER //
// ./src/app/constants/payments.constant.js